import { createStore, applyMiddleware, combineReducers } from "redux";
import {
  globaReducer,
  testReducer,
  studentReducer,
  testSummeryReducer,
  editModalReducer,
  editReportedModalReducer,
  surveyReducer,
  singleTestReducer,
  paramReducer,
  profilePageReducer,
  radarChartReducer,
  messageReducer,
  filterStateReducer,
  publishStudentReducer,
  offlineSyncReducer,
  flagNotesReducer,
  refreshApiReducer,
} from "./reducer/reducer";
import { auth, schoolCode } from "./reducer/auth";
import { surveyQuestion } from "./reducer/survey.js";
import { feedbackQuestion, feedbackSummery } from "./reducer/feedback.js";
import thunk from "redux-thunk";
import logger from "redux-logger";

const rootReducer = combineReducers({
  globaReducer,
  testReducer,
  studentReducer,
  testSummeryReducer,
  surveyReducer,
  singleTestReducer,
  editModalReducer,
  editReportedModalReducer,
  auth,
  schoolCode,
  surveyQuestion,
  feedbackQuestion,
  feedbackSummery,
  paramReducer,
  profilePageReducer,
  radarChartReducer,
  messageReducer,
  filterStateReducer,
  publishStudentReducer,
  offlineSyncReducer,
  flagNotesReducer,
  refreshApiReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk, logger));

export default store;
